import Utils from '../utils/utils';
import {module} from "modujs";
import axios from "axios";
import gsap from 'gsap';
import emitter from 'tiny-emitter/instance';

export default class extends module {

  constructor(m) {

    super(m);

    this.$container = this.el
    this.$form = this.el.querySelector('form')
    this.$close = this.el.querySelector('.newsletter-content--close');
    this.$openBtn = document.querySelector('.navbar-social--item-suscribe');
  }

  init() {

    let cookieVal = sessionStorage['newsletter_anjac'] === undefined ? '' : sessionStorage['newsletter_anjac'];
    let self = this;

    //console.log("✅NEWSLETTER INIT✅", cookieVal)
    this.close()

    // document.body.classList.add('newsletterOpened');


    this.$form.addEventListener('change', () => {
      self.verifyCheckboxStyle()
    })

    this.$form.addEventListener("submit", function (e) {
      e.preventDefault();

      let data = self.createQuery()
      if (data) {
        self.post(data)
      }
    })

    if (cookieVal === 'set' || cookieVal === 'closed') {
      this.close()
    // on va lancer la popin au bout de X Secondes
    } else {
      setTimeout(this.open.bind(this), 15000);
    }

    this.$openBtn.addEventListener('click', (e) => {
      e.preventDefault()
      this.open();
    })

    this.$close.addEventListener("click", function (e) {
      self.close()
      self.cookieClose()
    })
  }

  /**
   * Create Query Object for CPT Newsletter
   */
  createQuery() {

    const mail = this.$form.querySelector('input[type="email"]').value
    const checkboxField = this.$form.querySelectorAll('input[type="checkbox"]')

    if (!this.validateEmail(mail)) {
      //console.log("Wrong Mail, please retry")
      return null;
    }

    let obj = [];

    for (let i = 0; i < checkboxField.length; i++) {
      let item = checkboxField.item(i);
      if (item.checked) {
        obj.push(item.name);
      }
    }

    const queryItem = {
      mail: mail,
      checkbox: obj
    }
    return queryItem
  }

  /**
   * Create Post in CPT Newsletter
   */
  post(query) {

    Utils.debug('Create Post Newsletter');
    let form_data = new URLSearchParams();

    form_data.append('action', 'ajax_create_newsletter_post');
    form_data.append('mail', query.mail);
    form_data.append('_ajax_nonce', ajax_object.ajax_nonce);
    form_data.append('newsletter', query.checkbox);


    axios.post(ajax_object.ajax_url, form_data)
      .then((response) => {
        //console.log(response);
        this.hide()
      })

      .catch((error) => {
        //console.log(error);
      });
  }

  open() {

    //console.log("✅NEWSLETTER :: open✅")
    document.body.classList.add('newsletterOpened');
    // window.scrollTo({
    //   top: 0,
    //   behavior: "smooth"
    // });

    sessionStorage['newsletter_anjac'] = '';
    let msg = this.$container.querySelector('.valid-msg')
    let input = this.$form.querySelector('#mail')
    let close = this.$container.querySelector('.newsletter-content--close')
    this.$container.classList.add('visible');

    if (msg) {
      msg.style.display = 'none';
    }
    if (Utils.desktopBurger()){
      emitter.emit('barba::after')
    }

    this.$form.style.display = ''
    input.value = ''
    close.style.display = ''

    let tl = gsap.timeline()
    tl.to(this.$container, {display: 'flex'})
    tl.to(this.$container, {opacity: 1, duration: .5})
  }

  hide() {

    //console.log("✅NEWSLETTER :: hide✅")
    //document.body.classList.remove('newsletterOpened');

    let self = this;
    const txt = this.el.querySelector('.newsletter-content>p')
    const newItem = document.createElement('p');

    this.$form.style.display = "none"
    this.$close.style.display = "none"
    this.cookieAccept()

    const thankYou = '<strong>Merci, votre inscription à bien été prise en compte !</strong>'

    newItem.classList.add('valid-msg')
    newItem.innerHTML = thankYou;
    txt.parentNode.replaceChild(newItem, txt);

    //Faire l'anim
    setTimeout(function () {
      self.$container.style.display = "none"
    }, 2000);
  }


  close() {
    //console.log("✅NEWSLETTER :: close✅")
    document.body.classList.remove('newsletterOpened');
    this.$container.classList.remove('visible');
    let tl = gsap.timeline()
    tl.to(this.$container, {opacity: 0, duration: .5})
    tl.to(this.$container, {display: 'none'})
  }

  cookieClose() {
    sessionStorage['newsletter_anjac'] = 'closed';
  }

  cookieAccept() {
    sessionStorage['newsletter_anjac'] = 'set';
  }

  validateEmail(email) {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  }

  verifyCheckboxStyle() {
    const checkboxField = this.$form.querySelectorAll('input[type="checkbox"]')
    checkboxField.forEach((item) => {
      if (item.checked) {
        item.parentElement.style.color = '#1C2544';
      } else item.parentElement.style.color = ''
    })
  }

  destroy() {
    // destroy method
    //console.log('NEWSLETTER DESTROYED')
    this.$form.removeEventListener('submit', this)
    this.$form.removeEventListener('change', this)
    this.$close.removeEventListener('click', this)
  }

}



// WEBPACK FOOTER //
// ./scripts/modules/newsletter.js